/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermsDto } from '../../models/terms-dto';

export interface TermsControllerActivate$Params {
  id: string;
}

export function termsControllerActivate(http: HttpClient, rootUrl: string, params: TermsControllerActivate$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
  const rb = new RequestBuilder(rootUrl, termsControllerActivate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermsDto>;
    })
  );
}

termsControllerActivate.PATH = '/api/terms/{id}/activate';
